import type { FC } from 'react';
import React from 'react';
import type { DLClickEventHandlerProps } from 'tsconfig/types';
import { inspectorMode } from 'common-ui';

interface HandleLevel3LinksProps {
  url: string | undefined;
  level2MenuContentTitle: string;
  level3MenuContentTitle: string;
  linkContentTitle: string;
  linkContentId: string;
  dlClickEventHandler: DLClickEventHandlerProps;
}
const HandleLevel3Links: FC<HandleLevel3LinksProps> = ({
  url,
  level2MenuContentTitle,
  level3MenuContentTitle,
  linkContentTitle,
  linkContentId,
  dlClickEventHandler,
}): React.ReactElement => (
  <a
    href={url}
    className="level3Link"
    onClick={() => dlClickEventHandler(`${level2MenuContentTitle}:${level3MenuContentTitle}:${linkContentTitle}`)}
    {...inspectorMode(linkContentId, 'title')}
  >
    {linkContentTitle}
  </a>
);

export default HandleLevel3Links;
